import { SITE_PAGES } from 'Config';
import AppData from 'Data/AppData';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

const LogoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AppData.logout();
    navigate(SITE_PAGES.HOME.to);
  }, []);

  return <div />;
};

export default LogoutPage;
